import * as React from "react";
import { Grid } from "@mui/material";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";

const AgentMetricsDetails = () => {
  const metricsData = React.useMemo(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("UIAgentMetricsResponse") || "{}");
      const parsedBody = raw.body ? JSON.parse(raw.body) : {};
      return Array.isArray(parsedBody) ? parsedBody : [];
    } catch (err) {
      console.error("Error parsing metrics data:", err);
      return [];
    }
  }, []);

  const [selectedAgentIndex, setSelectedAgentIndex] = React.useState(null);

  const handleAgentClick = (index) => {
    setSelectedAgentIndex(index === selectedAgentIndex ? null : index);
  };

  return (
    <MainTheme>
      <Title title="Agent Metrics" />
      <div className="organization-details-section">
        <Grid container spacing={2} className="container-section">
          <Grid item xs={12}>
            {metricsData.length === 0 ? (
              <p>No metrics available.</p>
            ) : (
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  alignItems: "flex-start",
                }}
              >
                {/* Left side - Agent list */}
                <div
                  style={{
                    width: "220px",
                    maxHeight: "320px", // ~7 buttons tall
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <h3 style={{ marginTop: 0 }}>Agents</h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {metricsData.map((agent, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>
                        <div
                          onClick={() => handleAgentClick(index)}
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            backgroundColor:
                              index === selectedAgentIndex ? "#e0e0e0" : "#f5f5f5",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {agent["Agent"] || `Agent ${index + 1}`}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Right side - Metrics table */}
                <div style={{ flex: 1 }}>
                  {selectedAgentIndex !== null ? (
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        maxHeight: "320px", // ~7 rows
                        overflowY: "auto",
                      }}
                    >
                      <h3 style={{ marginTop: 0 }}>
                        {metricsData[selectedAgentIndex]["Agent"] ||
                          `Agent ${selectedAgentIndex + 1}`}{" "}
                        Metrics
                      </h3>
                      <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #ccc",
                                padding: "6px",
                                backgroundColor: "#f0f0f0",
                                position: "sticky",
                                top: 0,
                              }}
                            >
                              Metric
                            </th>
                            <th
                              style={{
                                border: "1px solid #ccc",
                                padding: "6px",
                                backgroundColor: "#f0f0f0",
                                position: "sticky",
                                top: 0,
                              }}
                            >
                              Value
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(metricsData[selectedAgentIndex]).map(
                            ([key, value]) =>
                              key !== "Agent" && (
                                <tr key={key}>
                                  <td
                                    style={{
                                      border: "1px solid #ccc",
                                      padding: "6px",
                                    }}
                                  >
                                    {key}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ccc",
                                      padding: "6px",
                                    }}
                                  >
                                    {value}
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>Select an agent to view their metrics.</p>
                  )}
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default AgentMetricsDetails;
